// Assigns the values of the source to the destination.
export const safeAssign = <TDest extends TSource, TSource>(dest: TDest, source: TSource) => {
  return Object.assign(dest as {}, source) as TDest;
};
